import { links } from "components/SidebarRoutes";
import { Route } from "react-router-dom";
import useGetConsignmentStatus from "utils/hooks/options/useGetConsignmentStatus";
import useGetConsignmentTypes from "utils/hooks/options/useGetConsignmentTypes";
import useGetExeptions from "utils/hooks/options/useGetExeptions";
import useGetServiceTypes from "utils/hooks/options/useGetServiceTypes";
import useSetPermissionRoutesDispatches from "utils/hooks/useSetPermissionRoutesDispatches";
import ProtectedRoute from "./ProtectedRoute";
const PermissionRoute = () => {
  useSetPermissionRoutesDispatches();
  useGetExeptions();
  useGetServiceTypes();
  useGetConsignmentStatus();
  useGetConsignmentTypes();
  return links.map(({ childs }, parentIdx) => {
    return childs.map(({ to, component, permissions }, childIdx: number) => {
      return (
        <Route
          key={`${parentIdx}-${childIdx}`}
          element={<ProtectedRoute permission={permissions} />}
        >
          <Route path={to} element={component} />
        </Route>
      );
    });
  });
};

export default PermissionRoute;
